<h2 mat-dialog-title>Deactivate {{ data.row.name }}?</h2>

<mat-dialog-content>
  <p>Inactive items won't appear in dropdowns.</p>

  <!-- System-default guard: require typed "CONFIRM" -->
  <ng-container *ngIf="isSystemDefault">
    <p class="system-default-warn br-alert">
      This is a system-default record. Type <strong>CONFIRM</strong> to proceed.
    </p>
    <mat-form-field appearance="outline" class="confirm-input" subscriptSizing="dynamic">
      <input matInput
             [(ngModel)]="confirmInput"
             placeholder="Type CONFIRM"
             (keyup.enter)="confirmReady && !deactivating && confirm()" />
    </mat-form-field>
  </ng-container>

  <p *ngIf="errorMessage" class="deactivate-error br-alert br-alert--danger">{{ errorMessage }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="br-btn br-btn--ghost" (click)="cancel()" [disabled]="deactivating">Cancel</button>
  <button type="button" class="br-btn br-btn--danger" [disabled]="deactivating || !confirmReady" (click)="confirm()">
    {{ deactivating ? 'Deactivating…' : 'Deactivate' }}
  </button>
</mat-dialog-actions>
